angular.module('hal-common').directive('textSelector', [
  '$timeout',
  '$window',
  function ($timeout, $window) {
    return {
      restrict: 'E',
      scope: {
        selection: '=',
        text: '=',
        selecting: '=',
        onSelectionChange: '&',
      },
      templateUrl: '/templates/hal-common/directives/text-selector.html',
      controller: [
        '$scope',
        function ($scope) {
          $scope.hover = false;
          $scope.hoverDrag = 'move';
          $scope.letters = [];

          $scope.dragging = false;
          $scope.moving = false;
          $scope.drag_side = false;
          $scope.drag_origin_x = false;
          $scope.drag_origin_y = false;
          $scope.drag_move_x = false;
          $scope.drag_move_y = false;
          $scope.drag_move_offset = 0;
          $scope.drag_box_index = false;
          $scope.container = false;

          $scope.determineLetters = function () {
            $scope.letters = [];
            for (var x = 0; x < $scope.text.length; x++) {
              $scope.letters.push($scope.text[x]);
            }
          };

          // Watch for changes to the selection boxes
          $scope.determineLetters();
          $scope.$watch(
            'selection',
            function (old_val, new_val) {
              if ($scope.selection[0] < 0) {
                $scope.selection[0] = 0;
              }
              if ($scope.selection[1] < 1) {
                $scope.selection[1] = 1;
              }
              if ($scope.selection[0] > $scope.letters.length - 2) {
                $scope.selection[0] = $scope.letters.length - 2;
              }
              if ($scope.selection[1] > $scope.letters.length - 1) {
                $scope.selection[1] = $scope.letters.length - 1;
              }
              $scope.drawSelectBox();
            },
            true
          );

          $scope.letterSelected = function (index) {
            if (!$scope.selecting) {
              return false;
            }
            if ($scope.selection[0] <= index && $scope.selection[1] >= index) {
              return true;
            }
            return false;
          };

          $scope.isFirstLetter = function (index) {
            return $scope.selection[0] == index;
          };

          $scope.isLastLetter = function (index) {
            return $scope.selection[1] == index;
          };

          $scope.mouseMove = function ($event) {
            var drag = 'left';
            var box = angular.element($event.target);
            if (box) {
              var first_letter = $scope.container.find('span').eq($scope.selection[0]);
              var last_letter = $scope.container.find('span').eq($scope.selection[1]);

              var first_letter_left = first_letter.offset().left;
              var first_letter_right = first_letter_left + first_letter.width();
              var first_letter_top = first_letter.offset().top;
              var first_letter_bottom = first_letter_top + first_letter.height();

              var last_letter_left = last_letter.offset().left;
              var last_letter_right = last_letter_left + last_letter.width();
              var last_letter_top = last_letter.offset().top;
              var last_letter_bottom = last_letter_top + last_letter.height();

              if (
                $event.clientX > last_letter_left &&
                $event.clientY > last_letter_top &&
                $event.clientY < last_letter_bottom
              ) {
                drag = 'right';
              } else if (
                $event.clientX < first_letter_right &&
                $event.clientY > first_letter_top &&
                $event.clientY < first_letter_bottom
              ) {
                drag = 'left';
              } else {
                drag = 'move';
              }

              if (!$scope.hover || drag != $scope.hoverDrag) {
                $scope.hover = true;
                $scope.hoverDrag = drag;
                $scope.drawSelectBox();
              }
            }

            if ($scope.dragging || $scope.moving) {
              $scope.drag_move_x = $event.clientX - $scope.drag_origin_x;
              $scope.drag_move_y = $event.clientY - $scope.drag_origin_y;
              if ($scope.dragging && $scope.drag_side == 'right') {
                $scope.drag_move_x += 8;
              } else if ($scope.dragging && $scope.drag_side == 'left') {
                $scope.drag_move_x -= 8;
              }
              if ($scope.dragging) {
                var new_letter = $scope.getLetterByOffset($scope.drag_origin_x + $scope.drag_move_x, $event.clientY);
                if (new_letter) {
                  // Resize the select box
                  if ($scope.drag_side == 'left') {
                    $scope.selection[0] = new_letter.data('index');
                  } else if ($scope.drag_side == 'right') {
                    $scope.selection[1] = new_letter.data('index');
                  }
                }
              } else {
                // Move the select box
                var start_letter = $scope.getLetterByOffset($scope.drag_origin_x, $event.clientY);
                var offset_letter = $scope.getLetterByOffset($scope.drag_origin_x + $scope.drag_move_x, $event.clientY);
                if (start_letter && offset_letter) {
                  var index_offset = parseInt(offset_letter.data('index')) - parseInt(start_letter.data('index'));
                  $scope.selection[0] += index_offset - $scope.drag_move_offset;
                  $scope.selection[1] += index_offset - $scope.drag_move_offset;
                  $scope.drag_move_offset += index_offset - $scope.drag_move_offset;
                }
              }
            }
          };

          $scope.getLetterByOffset = function (x, y) {
            var closest_letter = false;
            $scope.container.find('span.letter').each(function () {
              if (
                x > $(this).offset().left &&
                x < $(this).offset().left + $(this).width() &&
                y > $(this).offset().top &&
                y < $(this).offset().top + $(this).height()
              ) {
                closest_letter = $(this);
              }
            });
            return closest_letter;
          };

          $scope.mouseDown = function ($event) {
            if ($scope.hoverDrag == 'move') {
              $scope.startMoving($event);
            } else if ($scope.hoverDrag == 'left') {
              $scope.startDragBeginning($event);
            } else {
              $scope.startDragEnd($event);
            }
          };

          $scope.startMoving = function ($event) {
            $scope.moving = true;
            $scope.drag_origin_x = $event.clientX;
            $scope.drag_origin_y = $event.clientY;
            $scope.drag_move_offset = 0;
          };

          $scope.startDragBeginning = function ($event) {
            $scope.dragging = true;
            $scope.drag_side = 'left';
            $scope.drag_origin_x = $event.clientX;
            $scope.drag_origin_y = $event.clientY;
          };

          $scope.startDragEnd = function ($event) {
            $scope.dragging = true;
            $scope.drag_side = 'right';
            $scope.drag_origin_x = $event.clientX;
            $scope.drag_origin_y = $event.clientY;
          };

          $scope.mouseUp = function ($event) {
            $scope.dragging = false;
            $scope.moving = false;
            $scope.drag_side = false;
            $scope.drag_origin_x = false;
            $scope.drag_origin_y = false;
            $scope.hoverDrag = false;

            if ($scope.onSelectionChange) {
              var selected_text = '';
              for (var i = 0; i < $scope.letters.length; i++) {
                if ($scope.letterSelected(i)) {
                  selected_text += $scope.letters[i];
                }
              }

              $scope.onSelectionChange({ $text: selected_text });
            }
          };

          $scope.mouseOut = function ($event) {
            if (!$event.toElement || ['letter', 'space'].indexOf($event.toElement.className) == -1) {
              $scope.hover = false;
              $scope.dragging = false;
              $scope.moving = false;
            }
          };

          $scope.drawSelectBox = function () {
            var start_letter = $scope.container.find('span[data-index=' + $scope.selection[0] + ']');
            var end_letter = $scope.container.find('span[data-index=' + $scope.selection[1] + ']');
            var start_offset = start_letter.position();
            var end_offset = end_letter.position();
            if (start_letter && end_letter && start_offset && end_offset) {
              var pos = {
                top: start_offset.top,
                left: start_offset.left - 4,
                width: end_offset.left + end_letter.width() - start_offset.left + 8,
                height: end_letter.height(),
              };
            }
          };
        },
      ],

      link: function (scope, element) {
        scope.container = element.find('.text-selector');
        angular.element($window).bind('resize', function () {
          scope.drawSelectBox();
        });
        $timeout(scope.drawSelectBox, 0);
      },
    };
  },
]);
